import { collection, doc, getDoc, getDocs, addDoc, updateDoc, deleteDoc, query, where, orderBy, limit } from "firebase/firestore";
import { db } from "../config/firebase";

const COLLECTION = "hocSinh";

// ✅ Đã có - giữ nguyên
export const getHocSinhByLop = async (lopId) => {
  const q = query(collection(db, COLLECTION), where("lopHienTaiId", "==", lopId));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

// ✅ Đã có - giữ nguyên
export const addHocSinh = async (data) => {
  const docRef = await addDoc(collection(db, COLLECTION), { ...data, ngayTao: new Date().toISOString() });
  return docRef.id;
};

// ✅ Đã có - giữ nguyên
export const updateHocSinh = async (id, data) => {
  await updateDoc(doc(db, COLLECTION, id), { ...data, ngayCapNhat: new Date().toISOString() });
};

// ✅ Đã có - giữ nguyên
export const deleteHocSinh = async (id) => { await deleteDoc(doc(db, COLLECTION, id)); };

// ✅ Đã có - giữ nguyên
export const getHocSinhById = async (id) => {
  const docSnap = await getDoc(doc(db, COLLECTION, id));
  return docSnap.exists() ? { id: docSnap.id, ...docSnap.data() } : null;
};

// ✅ Đã có - giữ nguyên
export const getLichSuHocSinh = async (hocSinhId) => {
  const snapshot = await getDocs(collection(db, COLLECTION, hocSinhId, "lichSu"));
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

// ✅ Đã có - giữ nguyên
export const addLichSuHocSinh = async (hocSinhId, data) => {
  await addDoc(collection(db, COLLECTION, hocSinhId, "lichSu"), { ...data, ngayTao: new Date().toISOString() });
};

// ✅ Đã có - giữ nguyên
export const getDiemSoHocSinh = async (hocSinhId, namHoc) => {
  const q = query(collection(db, COLLECTION, hocSinhId, "diemSo"), where("namHoc", "==", namHoc));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

// ✅ Đã có - giữ nguyên
export const addDiemSo = async (hocSinhId, data) => {
  await addDoc(collection(db, COLLECTION, hocSinhId, "diemSo"), { ...data, ngayTao: new Date().toISOString() });
};

// ✅ Đã có - giữ nguyên
export const getLichSuDiemDanhHS = async (hocSinhId, lopId) => {
  const q = query(collection(db, "diemDanh"), where("hocSinhId", "==", hocSinhId), where("lopId", "==", lopId));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

// ===== 🆕 THÊM MỚI =====

// Đếm tổng số học sinh (dùng cho Admin badge)
export const countAllHocSinh = async () => {
  const snapshot = await getDocs(collection(db, COLLECTION));
  return snapshot.size;
};

// Đếm học sinh theo lớp
export const countHocSinhByLop = async (lopId) => {
  const q = query(collection(db, COLLECTION), where("lopHienTaiId", "==", lopId));
  const snapshot = await getDocs(q);
  return snapshot.size;
};

// Lấy tất cả học sinh (dùng cho Admin)
export const getAllHocSinh = async () => {
  const snapshot = await getDocs(collection(db, COLLECTION));
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

// Đếm học sinh theo ngành (dùng cho Trưởng ngành)
export const countHocSinhByNganh = async (maNganh) => {
  const snapshot = await getDocs(collection(db, COLLECTION));
  return snapshot.docs.filter(doc => doc.data().lopHienTaiId?.startsWith(maNganh)).length;
};